import { useState } from "react";
import { useBidContext } from "../Bid.context";
import React from "react";
import { Alert, Box, Button, Modal, Typography } from "@mui/material";
import { modalStyle } from "../../../../../../../../components/modalStyle";

import { postBidSelection } from "../api";
import POSubmissionTable from "./POSubmissionTable";

export const BidTableButton = () => {
  const { BidTableRows, setBidTableRows, mrqData } = useBidContext();

  const [alert, setAlert] = React.useState("");
  const [openPOSubmitModal, setOpenPOSubmitModal] = useState(false);

  const handleOpenModal = () => setOpenPOSubmitModal(true);
  const handleCloseModal = () => setOpenPOSubmitModal(false);

  const isBidTableButtonDisabled = () => {
    let disabled = true;

    BidTableRows?.forEach((row) => {
      if (row.po) disabled = false;
    });

    return disabled;
  };

  const onReset = () => {
    setBidTableRows(
      BidTableRows.map((r) => {
        return { ...r, po: "", selected: {}, vendorId: "" };
      }),
    );
  };

  // const onSubmit = async () => {
  //   const data = await postBidSelection({
  //     mrqId: mrqData.id,
  //     bidsSelection: BidTableRows,
  //   });
  //   if (data && data[0] && data[0].id) {
  //     setAlert("success");
  //   } else {
  //     setAlert("warning");
  //   }
  // };

  const onSubmitPos = () => {
    handleOpenModal();
  };

  return (
    <>
      {alert ? (
        <Alert
          severity={alert}
          sx={{ width: "100%" }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                setAlert("");
              }}
            >
              Edit
            </Button>
          }
        >
          Thanks, Changes has been saved.
        </Alert>
      ) : (
        <>
          <Button
            disabled={isBidTableButtonDisabled()}
            variant="contained"
            sx={{ float: "right" }}
            onClick={onSubmitPos}
            // onClick={onSubmit}
          >
            Submit Bids Selection
          </Button>

          <Button
            disabled={isBidTableButtonDisabled()}
            sx={{ float: "right", mr: 2 }}
            onClick={onReset}
          >
            Reset All
          </Button>

          <Modal open={openPOSubmitModal} onClose={handleCloseModal}>
            <Box sx={{ ...modalStyle, width: 700 }}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ mb: 2 }}
              >
                Submit Selection POs
              </Typography>

              <POSubmissionTable setAlert={setAlert} />
            </Box>
          </Modal>
        </>
      )}
    </>
  );
};
